/** Display candidate as first initial + *** (e.g. Phil Wang → P***, Sijun → S***). */
export function maskCandidateName(name) {
  const s = (name == null ? '' : String(name)).trim();
  if (!s) return '—';
  return `${s.charAt(0).toUpperCase()}***`;
}

/** First name + space + last name for profile defaults. */
export function formatProfileFullName(profile) {
  const first = (profile?.firstName || '').trim();
  const last = (profile?.lastName || '').trim();
  return [first, last].filter(Boolean).join(' ');
}
